/**
 * @module Support
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
import {
  CartItem,
  CartLine,
  Cart,
} from '@support/api/proxies/responses/api-cart-response.interface';

/** */
export class CartUtils {
  constructor() {}

  /**
   * Get Cart Item based on status Code from a cart line or Cart
   * @param lineItem - CartLine or Cart from which we need to retrieve LineItem
   * @param status - String value of status based on which we need to filter out Cart Item
   * @param itemtype - Name (in string) of the item type that needs to be filter out
   * @param checkNegation - Optional parameter - if true check for negation while filtering out cart items
   * @returns  CartItem[]
   */
  public static getCartItemAsArrayFromLine(
    lineItem: CartLine | Cart,
    status: string,
    itemType: string,
    checkNegation?: boolean
  ): CartItem[] {
    if (lineItem && lineItem[itemType]) {
      if (Array.isArray(lineItem[itemType])) {
        const arrFiltered = lineItem[itemType].filter((item: CartItem) => {
          // if checkNegation is true then check if not equals to status or else check if equals to status
          if (checkNegation) {
            return item.actionCode !== status;
          } else {
            return item.actionCode === status || item.statusCode === status;
          }
        });
        return arrFiltered && arrFiltered.length > 0 ? arrFiltered : null;
      } else {
        return [lineItem[itemType]];
      }
    } else {
      return null;
    }
  }

  /**
   * get cart item based on Status code from a Cart line
   * @param lineItem - CartLine or Cart from which we need to retrieve LineItem
   * @param status - String value of status based on which we need to filter out Cart Item
   * @param itemtype - Name (in string) of the item type that needs to be filter out
   * @param checkNegation - Optional parameter - if true check for negation while filtering out cart items
   * @returns  CartItem
   */
  public static getCartItemFromLine(
    lineItem: CartLine,
    status: string,
    itemType: string,
    checkNegation?: boolean
  ): CartItem {
    if (lineItem && lineItem[itemType]) {
      if (Array.isArray(lineItem[itemType])) {
        const arrFiltered = lineItem[itemType].filter((item: CartItem) => {
          // if checkNegation is true then check if not equals to status or else check if equals to status
          if (checkNegation) {
            return item.actionCode !== status;
          } else {
            return item.actionCode === status || item.statusCode === status;
          }
        });
        return arrFiltered && arrFiltered.length > 0 ? arrFiltered[0] : null;
      } else {
        if (checkNegation) {
          return lineItem[itemType];
        } else {
          return lineItem[itemType].actionCode === status ||
            lineItem[itemType].statusCode === status
            ? lineItem[itemType]
            : null;
        }
      }
    } else {
      return null;
    }
  }
}
